export default Object.freeze({
  Agent: 'Agent',
  Customer: 'Customer',
  Anyone: 'Anyone',
});
